import React, { useState } from "react";
import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Tooltip,
} from "@material-ui/core";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

export default function ConfigSectionInfo({ titulo, children }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Tooltip title="¿Para qué sirve esta sección?">
        <IconButton onClick={() => setOpen(true)}>
          <InfoOutlinedIcon color="primary" />
        </IconButton>
      </Tooltip>
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>{titulo}</DialogTitle>
        <DialogContent>
          <DialogContentText component="div">{children}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpen(false)} color="primary">
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
